module.exports = __webpack_public_path__ + "static/media/p_feature1.63e45ade.png";